var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFadeStar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.042,
    height: 22.852,
    viewBox: "0 0 24.042 22.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.55,1.333a.5.5,0,0,1,.943,0l2.419,6.841a.5.5,0,0,0,.459.333l7.257.185a.5.5,0,0,1,.291.9L17.157,14a.5.5,0,0,0-.175.539L19.048,21.5a.5.5,0,0,1-.763.554L12.3,17.937a.5.5,0,0,0-.567,0L5.757,22.05a.5.5,0,0,1-.763-.554L7.06,14.541A.5.5,0,0,0,6.885,14L1.124,9.589a.5.5,0,0,1,.291-.9l7.257-.185a.5.5,0,0,0,.459-.333Z",
    opacity: 0.202
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFadeStar);
export default __webpack_public_path__ + "static/media/fadeStar.532974f15fadd1331474f95165170001.svg";
export { ForwardRef as ReactComponent };